import React from 'react';
import { Facebook, Instagram, Phone, MapPin, UtensilsCrossed, Navigation } from 'lucide-react';
import { restaurantInfo } from '../config/siteConfig';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1612] text-[#FDF6E9]">
      {/* Main footer */}
      <div className="max-w-6xl mx-auto px-5 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-14 h-14 rounded-full bg-[#C9A227]/10 flex items-center justify-center overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_elegant-satchmos/artifacts/5uip0vr0_680-removebg-preview.png"
                  alt=""
                  className="w-full h-full object-cover"
                  style={{ transform: 'scale(1.45)' }}
                />
              </div>
              <div>
                <span className="font-display text-2xl tracking-wide">SATCHMO'S</span>
                <span className="block text-xs text-[#D4A574] tracking-widest">BAR & GRILL</span>
              </div>
            </div>
            <p className="text-[#FDF6E9]/50 text-sm leading-relaxed">
              Good food. Cold drinks. Great times. Your neighborhood spot since 2013.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-lg tracking-wide mb-4 text-[#D4A574]">CONTACT</h3>
            <div className="space-y-3 text-sm text-[#FDF6E9]/60">
              <a href={`tel:${restaurantInfo.phone.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 hover:text-[#D4A574] transition-colors">
                <Phone className="w-4 h-4" />
                {restaurantInfo.phone}
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5" />
                <div>
                  <p>{restaurantInfo.address}</p>
                  <p>{restaurantInfo.city}, {restaurantInfo.state} {restaurantInfo.zip}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-display text-lg tracking-wide mb-4 text-[#D4A574]">HOURS</h3>
            <div className="text-sm text-[#FDF6E9]/60 space-y-1">
              <p>Sun – Thu: 11am – 9pm</p>
              <p>Fri – Sat: 11am – 10pm</p>
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-display text-lg tracking-wide mb-4 text-[#D4A574]">FOLLOW US</h3>
            <p className="text-[#FDF6E9]/60 text-sm leading-snug mb-4">
              Daily specials and events drop on Facebook first.
            </p>
            <div className="flex gap-3">
              {restaurantInfo.social.facebook && (
                <a
                  href={restaurantInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-[#FDF6E9]/10 flex items-center justify-center hover:bg-[#C9A227] transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
              )}
              {restaurantInfo.social.instagram && (
                <a
                  href={restaurantInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-[#FDF6E9]/10 flex items-center justify-center hover:bg-[#C9A227] transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Quick actions */}
      <div className="border-t border-[#FDF6E9]/10">
        <div className="max-w-6xl mx-auto px-5 py-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={restaurantInfo.orderOnlineUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 bg-[#C9A227] text-[#1a1612] font-display text-lg tracking-wide hover:bg-[#d4ad2e] transition-colors"
          >
            <UtensilsCrossed className="w-4 h-4" />
            ORDER ONLINE
          </a>
          <a
            href={`tel:${restaurantInfo.phone.replace(/[^0-9]/g, '')}`}
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 border-2 border-[#D4A574]/60 text-[#D4A574] font-display text-lg tracking-wide hover:bg-[#D4A574] hover:text-[#1a1612] transition-colors"
          >
            <Phone className="w-4 h-4" />
            CALL US
          </a>
          <a
            href={restaurantInfo.directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 border-2 border-[#D4A574]/60 text-[#D4A574] font-display text-lg tracking-wide hover:bg-[#D4A574] hover:text-[#1a1612] transition-colors"
          >
            <Navigation className="w-4 h-4" />
            DIRECTIONS
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#FDF6E9]/10">
        <div className="max-w-6xl mx-auto px-5 py-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-center">
          <p className="text-[#FDF6E9]/55 text-sm">
            © {currentYear} Satchmo's Bar & Grill. All rights reserved.
          </p>
          <p className="text-[#FDF6E9]/55 text-xs">
            Named for the legendary Louis "Satchmo" Armstrong
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
